export namespace InvItemConstants {

    export enum AppletRouter {
        appletMainRouter = 'wavelet/erp/fin/inv-item-maintenance',
    }

    export enum InvItemTxnTypes {
        BASIC_ITEM = 'BASIC_ITEM',
        GROUPED_ITEM = 'GROUPED_ITEM',
        BUNDLE = 'BUNDLE',
        COUPON = 'COUPON',
        SERVICE = 'SERVICE',
        WARRANTY = 'WARRANTY',
        BATCH_EXPIRY = 'BATCH_EXPIRY',
        DOC_HEADER_ADJUSTMENT = 'DOC_HEADER_ADJUSTMENT'
    }
    export enum subItemTypeOptions {
        BASIC_QUANTITY = 'BASIC_QUANTITY',
        BATCH_NUMBER = 'BATCH_NUMBER',
        SERIAL_NUMBER = 'SERIAL_NUMBER',
        BIN_NUMBER = 'BIN_NUMBER'
    }
    export enum itemTaxApplicableOptions {

    }
    export enum DateFormat {
        DateFormat = 'YYYY-MM-DD',
        DateTimeFormat = 'YYYY-MM-DD HH:mm:ss'
    }

    export enum InvStatus {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE'
    }

    export enum InvItemExtTypes {
        GL_CODE = 'GL_CODE',
        ITEM_STATUS = 'ITEM_STATUS',
        ABBREVIATION = 'ABBREVIATION',
        LIST_CATEGORY_GUID = 'LIST_CATEGORY_GUID'
    }

    export enum InvCatGroupTypes {
        CP_COM = 'CP_COM',
        DOC_ITEM = 'DOC_ITEM',
        INV_ITEM_CATEGORY = 'INV_ITEM_CATEGORY',
    }

    export enum InvCategoryTypes {
        INVENTORY_ITEM_CATEGORY = 'INVENTORY_ITEM_CATEGORY',
    }
} 